import * as React from "react";
import { observer } from "mobx-react";
import { withStores } from "stores";
import { normalizeOptionsData } from "src/stores/FlexTemplateStore";
import { AdProps, AdViewProps, DisplayAdProps, AdFTNodeOptions } from "./typings";
import { Viewport, ViewSmall, ViewMedium, ViewLarge, ViewExtraLarge } from "bernie-view";
import { classNames } from "uitk-react-utils";

@observer
export class Ad extends React.Component<AdProps, {}> {
  public componentDidMount() {
    /* istanbul ignore next */
    if (this.props.advertising) {
      this.props.advertising.includeAd();
    }
  }

  public render() {
    const { advertising, flexModuleModelStore, flexTemplateNode } = this.props;

    /* istanbul ignore next */
    if (!advertising || !flexModuleModelStore || !flexTemplateNode) {
      return null;
    }

    if (advertising.adsSuppressed) {
      return null;
    }

    const options = normalizeOptionsData(
      flexTemplateNode,
      flexModuleModelStore.getModel(flexTemplateNode.id)
    ) as AdFTNodeOptions;

    return <AdView data-testid="ad-component" id={flexTemplateNode.id} options={options} advertising={advertising} />;
  }
}

const extraLargeAd = "CT1";
const largeAd = "CT2";
const mediumAd = "CT3";
const smallAd = "CT4";

const DisplayAd = (props: DisplayAdProps) => {
  const { id, options, uci, advertising } = props;

  const overrideMarginTop = options.marginTopOverride === "sizing__three";
  const displayAdClassNames = classNames("Ad all-cell-1-1 uitk-cell s-t-margin-six uitk-type-center", {
    "all-y-margin-three": overrideMarginTop,
    "all-y-margin-six": !overrideMarginTop,
    "background-color-white": options.backgroundWhite,
  });

  return (
    <div
      className={displayAdClassNames}
      id={id}
      data-fm={options.fmId}
      data-fm-title-id={options.fmTitleId}
      data-testid="display-ad"
    >
      <meso-display-ad uci={advertising?.adSlotIdOverride || uci} />
    </div>
  );
};

const AdView = observer((props: AdViewProps) => {
  const { options, id } = props;

  return (
    <Viewport>
      <ViewExtraLarge>
        <DisplayAd
          id={id}
          options={options}
          advertising={props.advertising}
          uci={options.extraLargeAd || extraLargeAd}
        />
      </ViewExtraLarge>
      <ViewLarge>
        <DisplayAd id={id} options={options} advertising={props.advertising} uci={options.largeAd || largeAd} />
      </ViewLarge>
      <ViewMedium>
        <DisplayAd id={id} options={options} advertising={props.advertising} uci={options.mediumAd || mediumAd} />
      </ViewMedium>
      <ViewSmall>
        <DisplayAd id={id} options={options} advertising={props.advertising} uci={options.smallAd || smallAd} />
      </ViewSmall>
    </Viewport>
  );
});

(AdView as React.SFC).displayName = "AdView";

export default withStores("advertising", "flexModuleModelStore")(Ad);
